// src/js/redesignImageAccordion.js
export function redesignImageAccordion() {
  const accordions = document.querySelectorAll(".redesign-image-accordion");
  accordions.forEach((accordion) => {
    accordion.querySelectorAll(".accordion-toggle").forEach((toggle) => {
      toggle.addEventListener("click", function () {
        const item = this.closest(".accordion-item");
        const contentWrapper = item.querySelector(".accordion-content-wrapper");
        const chevronDown = this.querySelector(".chevron-down");
        const chevronUp = this.querySelector(".chevron-up");
        const expanded = this.getAttribute("aria-expanded") === "true";
        
        // Close all other accordion items first
        accordion.querySelectorAll(".accordion-item").forEach((itm) => {
          if (itm !== item) {
            const otherToggle = itm.querySelector(".accordion-toggle");
            const otherContentWrapper = itm.querySelector(".accordion-content-wrapper");
            const otherChevronDown = otherToggle.querySelector(".chevron-down");
            const otherChevronUp = otherToggle.querySelector(".chevron-up");
            
            if (otherToggle.getAttribute("aria-expanded") === "true") {
              // Close this item
              otherContentWrapper.classList.remove("accordion-open");
              otherToggle.setAttribute("aria-expanded", "false");
              otherChevronDown.classList.remove("hidden", "rotate-180");
              otherChevronUp.classList.add("hidden");
              itm.setAttribute("data-expanded", "false");
            }
          }
        });
        
        // Toggle only the clicked item
        if (expanded) {
          // Close
          contentWrapper.classList.remove("accordion-open");
          this.setAttribute("aria-expanded", "false");
          chevronDown.classList.remove("hidden", "rotate-180");
          chevronUp.classList.add("hidden");
          item.setAttribute("data-expanded", "false");
        } else {
          // Open
          contentWrapper.classList.add("accordion-open");
          this.setAttribute("aria-expanded", "true");
          chevronDown.classList.add("hidden", "rotate-180");
          chevronUp.classList.remove("hidden");
          item.setAttribute("data-expanded", "true");
          
          // Switch main image if this accordion item has an associated image
          const preloadImageId = item.getAttribute("data-preload-image-id");
          const mainImageId = item.getAttribute("data-main-image-id");
          
          if (preloadImageId && mainImageId) {
            const preloadImage = document.getElementById(preloadImageId);
            const mainImage = document.getElementById(mainImageId);
            if (preloadImage && mainImage) {
              // Get the bundler-processed src from the hidden preload image
              const imageSrc = preloadImage.src;
              const imageAlt = preloadImage.alt;
              
              // Switch image instantly
              mainImage.src = imageSrc;
              mainImage.alt = imageAlt || "";
            }
          }
        }
      });
    });
  });
}
